import React from 'react';
import { Card, CardContent, Typography, CircularProgress, Box } from '@mui/material';

const LoadingCard = () => (
    <Card>
        <CardContent>
            <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
                <CircularProgress />
                <Typography variant="h6" mt={2}>Loading...</Typography>
            </Box>
        </CardContent>
    </Card>
);

export default LoadingCard;
